<template>
  <div style="width: 100%; overflow-y: auto; overflow-x: hidden; height: 100%">
    <div style="padding: 20px; width: 100%; box-sizing: border-box">
      <el-button
        size="small"
        @click="back"
        icon="el-icon-arrow-left"
        class="back"
        >返回</el-button
      >
      <el-row
        class="mt2"
        type="flex"
        justify="center"
        style="background: #fff; padding: 35px 0 20px 0"
      >
        <el-col :span="8">
          <el-steps
            :active="active"
            process-status="success"
            :align-center="true"
          >
            <el-step title="待提交"></el-step>
            <el-step title="已提交"></el-step>
            <el-step title="订单已审核"></el-step>
            <el-step title="订单已退订"></el-step>
          </el-steps>
        </el-col>
      </el-row>
      <el-row class="mt1" type="flex" justify="space-between">
        <el-col :span="17">
          <el-form
            ref="form"
            :inline="true"
            label-position="right"
            :model="form"
            :rules="formRules"
            :disabled="true"
            label-width="120px"
          >
            <el-row type="flex" justify="space-between" align="middle">
              <div class="title" style="width: 150px">
                车辆信息<span
                  @click="toCustomer"
                  style="color: #409eff"
                  v-if="formName != 'customerDetail'"
                  class="toCustomer"
                  >客户详情</span
                >
              </div>
              <el-form-item
                class="form_item"
                label-width="260px"
                v-if="form.extOrderId != ''"
                :label="'销售订单号:' + form.extOrderId"
              >
              </el-form-item>
            </el-row>
            <el-row style="background: #fff; padding: 15px 0">
              <!-- <el-form-item class="form_item"
                            label="合同编号"
                            prop="contractNo">
                <el-input size="mini"
                          style="width: 160px;"
                          placeholder="请输入"
                          v-model="form.contractNo"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            label="订单类型"
                            prop="orderType">
                <el-select size="mini"
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.orderType">
                  <el-option v-for="item in orderTypeDics"
                             :key="item.dataValue"
                             :label="item.dataDisplay"
                             :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item class="form_item" label="订购车型" prop="modelId">
                <el-cascader
                  size="mini"
                  class="filter-item"
                  disabled
                  style="width: 330px"
                  placeholder="选择订购车型"
                  filterable
                  :show-all-levels="true"
                  :options="carOptions"
                  v-model="form.modelId"
                ></el-cascader>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="车辆状态"
                v-if="form.otdStatus != ''"
              >
                <div style="width: 160px">{{ form.otdStatus }}</div>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="外观颜色"
                prop="modelColor"
              >
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.modelColor"
                  @change="getVins"
                >
                  <el-option
                    v-for="item in colors"
                    :key="item.color"
                    :label="item.color"
                    :value="item.color"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="内饰">
                <el-select size="mini" style="width:160px;" placeholder=""
                  v-model="form.carInternalColor">
                  <el-option v-for="(item, index) in carInternalColor" :key="index" :label="item === '' ? '无' : item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-for="(options, key) in carModelOptionalsComputed" :key="key" class="form_item" :label="modelOptionalsKeyMap.get(key)">
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.carModelOptionals[key]"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :value="item === '无选装' ? '' : item"
                    :label="item === '' ? '无' : item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item class="form_item"
                            label="车架号">
                <el-select size="mini"
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.modelVin">
                  <el-option v-for="item in vins"
                             :key="item.vin"
                             :label="item.vin"
                             :value="item.vin"></el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item class="form_item"
                            label="是否三包车"
                            prop="isSanbao">
                <el-select size="mini"
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.isSanbao">
                  <el-option :value="true"
                             label="是"></el-option>
                  <el-option :value="false"
                             label="否"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item class="form_item" label="订金" prop="paymentDown">
                <el-input
                  size="mini"
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.paymentDown"
                ></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="收款方式" prop="payType">
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.payType"
                >
                  <el-option label="全款" :value="1"></el-option>
                  <el-option label="按揭" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item class="form_item"
                            label="首付金额"
                            v-if="form.payType === 2">
                <el-input size="mini"
                          style="width: 160px;"
                          placeholder="请输入"
                          v-model="form.paymentFirst"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            v-if="form.payType === 2"
                            label="按揭期数">
                <el-select size="mini"
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.paymentYears">
                  <el-option v-for="item in orderLoadDurationDics"
                             :key="item.dataValue"
                             :label="item.dataDisplay"
                             :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item"
                            label="成交金额"
                            prop="paymentDeal">
                <el-input size="mini"
                          style="width: 160px;"
                          placeholder="请输入"
                          v-model="form.paymentDeal"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            label="其他费用">
                <el-input size="mini"
                          style="width: 160px;"
                          placeholder="请输入"
                          v-model="form.paymentOther"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            label="车辆用途"
                            prop="vehiclePurpose">
                <el-select size="mini"
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.vehiclePurpose">
                  <el-option v-for="item in orderVehiclePurposeDics"
                             :key="item.dataValue"
                             :label="item.dataDisplay"
                             :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item"
                            label="是否置换"
                            prop="isReplace">
                <el-select size="mini"
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.isReplace">
                  <el-option :value="true"
                             label="是"></el-option>
                  <el-option :value="false"
                             label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item"
                            label="置换车牌号"
                            v-if="form.isReplace">
                <el-input size="mini"
                          style="width: 160px;"
                          placeholder="请输入"
                          v-model="form.paymentOther"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            label="是否二级店销售">
                <el-select size="mini"
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.isReplace">
                  <el-option :value="true"
                             label="是"></el-option>
                  <el-option :value="false"
                             label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item"
                            label="二级店名称"
                            v-if="form.isReplace">
                <el-select size="mini"
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.storeName">
                  <el-option v-for="item in secondDealers"
                             :key="item"
                             :label="item"
                             :value="item"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item class="form_item" label="预计交车时间">
                <el-date-picker
                  size="mini"
                  style="width: 160px"
                  v-model="form.deliverDate"
                  :clearable="false"
                  type="date"
                  value-format="timestamp"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item class="form_item" label="订车原因">
                <el-select
                  size="mini"
                  style="width: 200px"
                  placeholder="请选择"
                  v-model="form.orderReason"
                  multiple
                >
                  <el-option
                    v-for="(item, index) in failProductReasonDics"
                    :key="index"
                    :label="item.dataName"
                    :value="item.dataName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="对比车型">
                <el-select
                  size="mini"
                  style="width: 250px"
                  placeholder="请选择"
                  v-model="form.competeSeriesId"
                >
                  <el-option
                    v-for="(item, index) in competitionSeries"
                    :key="index"
                    :label="item.brandName + ' ' + item.seriesName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="购车类型" prop="businessType">
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.businessType"
                  :disabled="disabled"
                >
                  <el-option
                    v-for="item in businessTypeOptions"
                    :key="item.dataValue"
                    :label="item.dataDisplay"
                    :value="item.dataValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row style="margin-top: 10px">
              <div class="title">客户信息</div>
            </el-row>
            <el-row style="background: #fff; padding: 15px 0">
              <el-form-item class="form_item" label="类型" prop="customerType">
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.customerType"
                >
                  <el-option label="个人" :value="1"></el-option>
                  <el-option label="企业" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="form_item"
                :label="form.customerType === 1 ? '订车人姓名' : '公司名称'"
                prop="customerName"
              >
                <el-input
                  size="mini"
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.customerName"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="联系电话"
                prop="customerPhone"
              >
                <el-input
                  size="mini"
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.customerPhone"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="证件类型"
                prop="identifyType"
              >
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.identifyType"
                >
                  <el-option
                    v-for="item in orderIdentifyTypeDics"
                    :key="item.dataValue"
                    :label="item.dataDisplay"
                    :value="item.dataValue"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="证件号码"
                prop="identifyNo"
              >
                <el-input
                  size="mini"
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.identifyNo"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="推荐人姓名"
                prop="referrerName"
              >
                <el-input
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.referrerName"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="推荐人电话"
                prop="referrerPhone"
              >
                <el-input
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.referrerPhone"
                ></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="省/市/区">
                <el-select
                  size="mini"
                  style="width: 100px"
                  placeholder="选择省"
                  clearable
                  @change="provinceChange"
                  v-model="form.customerProvince"
                >
                  <el-option
                    v-for="item in provinces"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <el-select
                  size="mini"
                  style="width: 100px"
                  placeholder="选择市"
                  clearable
                  @change="cityChange"
                  v-model="form.customerCity"
                >
                  <el-option
                    v-for="item in citys"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <el-select
                  size="mini"
                  style="width: 100px"
                  placeholder="选择区"
                  clearable
                  v-model="form.customerCounty"
                >
                  <el-option
                    v-for="item in countys"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="详细地址"
                prop="customerAddress"
              >
                <el-input
                  size="mini"
                  style="width: 300px"
                  placeholder="请输入"
                  v-model="form.customerAddress"
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row style="margin-top: 10px">
              <div class="title">其他信息</div>
              <el-row style="background: #fff; padding: 15px 0">
                <!-- <el-form-item class="form_item"
                              label="转他店交付">
                  <el-select size="mini"
                             style="width:160px;"
                             placeholder="请选择"
                             v-model="form.isOtherDealer">
                    <el-option :value="true"
                               label="是"></el-option>
                    <el-option :value="false"
                               label="否"></el-option>
                  </el-select>
                </el-form-item> -->
                <!-- <el-form-item class="form_item"
                              label="锐见报表统计">
                  <el-select size="mini"
                             style="width:160px;"
                             placeholder="请选择"
                             v-model="form.isReport">
                    <el-option :value="true"
                               label="是"></el-option>
                    <el-option :value="false"
                               label="否"></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item class="form_item" label="成交渠道">
                  <el-input v-if="form.reactivateSource" size="mini" style="width: 160px;" v-model="form.reactivateSource" disabled></el-input>
                  <el-input v-else size="mini" style="width: 160px;" v-model="form.sourceName" disabled></el-input>
                </el-form-item>
                <el-form-item class="form_item" label="备注">
                  <el-input
                    type="textarea"
                    style="width: 330px"
                    :rows="2"
                    placeholder="请输入备注内容"
                    v-model="form.remark"
                  >
                  </el-input>
                </el-form-item>
              </el-row>
              <el-row style="background: #fff; padding: 15px 0">
                <el-col :span="12">
                  <el-form-item
                    class="form_item"
                    label="订车合同/协议(最多三张)"
                    prop="images1"
                  >
                    <Upload ref="upload1" v-model="form.images1" disabled></Upload>
                    <!-- <el-upload
                      action
                      :limit="3"
                      disabled
                      :multiple="true"
                      :file-list="fileList1"
                      class="hide"
                      list-type="picture-card"
                    >
                      <i slot="default" class="el-icon-plus"></i>
                      <div slot="file" slot-scope="{ file }">
                        <img
                          class="el-upload-list__item-thumbnail"
                          :src="file.url"
                          alt=""
                        />
                        <span class="el-upload-list__item-actions">
                          <span
                            class="el-upload-list__item-preview"
                            @click="handlePictureCardPreview1(file)"
                          >
                            <i class="el-icon-zoom-in"></i>
                          </span>
                        </span>
                      </div>
                      <div
                        slot="tip"
                        v-if="fileList1.length > 0"
                        class="el-upload__tip"
                      >
                        支持JPG、JPEG、PNG格式
                      </div>
                    </el-upload> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="form_item" label="交易凭证">
                    <Upload ref="upload2" v-model="form.images2" disabled></Upload>
                    <!-- <el-upload
                      action
                      :limit="3"
                      ref="upload2"
                      :multiple="true"
                      disabled
                      :file-list="fileList2"
                      class="hide"
                      list-type="picture-card"
                    >
                      <i slot="default" class="el-icon-plus"></i>
                      <div slot="file" slot-scope="{ file }">
                        <img
                          class="el-upload-list__item-thumbnail"
                          :src="file.url"
                          alt=""
                        />
                        <span class="el-upload-list__item-actions">
                          <span
                            class="el-upload-list__item-preview"
                            @click="handlePictureCardPreview2(file)"
                          >
                            <i class="el-icon-zoom-in"></i>
                          </span>
                        </span>
                      </div>
                      <div
                        slot="tip"
                        v-if="fileList2.length > 0"
                        class="el-upload__tip"
                      >
                        支持JPG、JPEG、PNG格式
                      </div>
                    </el-upload> -->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="7" style="margin-left: 20px">
          <div class="title">订单操作记录</div>
          <el-row style="min-height: 628px; background: #fff">
            <el-timeline style="margin-top: 15px; margin-left: 30px">
              <el-timeline-item
                v-for="(item, index) in timelines"
                :key="index"
                color="#0bbd87"
                :timestamp="parseTime(item.createdAt, '{y}/{m}/{d} {h}:{i}')"
              >
                <div class="boxLine">
                  <div class="title">{{ item.orderStatus | orderStatus }}</div>
                  <span v-html="item.content.replaceAll('\n', '<br/>')"></span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="fileList"
      :initialIndex="initialIndex"
    />
  </div>
</template>

<script>
import ElImageViewer from "./image-viewer";
import { modelOptionalsKeyMap, orderStatusDics } from './constants.js'
import Upload from "@/components/common/Upload.vue";

var order_vm;
export default {
  components: { ElImageViewer, Upload },
  data() {
    order_vm = this;
    return {
      modelOptionalsKeyMap,
      initialIndex: 0,
      dealer: this.$common.getLoginInfo().profile,
      orderId: Number(this.$route.query.id),
      formName: sessionStorage.getItem("form"),
      type: this.$route.query.type,
      active: 4,
      dialogVisible: false,
      dialogImageUrl: "",
      fileList: [],
      fileList1: [],
      fileList2: [],
      form: {
        otdStatus: "",
        contractNo: "",
        orderType: "",
        modelId: "",
        modelColor: "",
        modelVin: "",
        isSanbao: true,
        paymentDown: "",
        payType: 1,
        paymentFirst: "",
        paymentYears: "",
        paymentDeal: "",
        paymentOther: "",
        vehiclePurpose: "",
        isReplace: false,
        customerType: 1,
        customerName: "",
        customerPhone: "",
        identifyType: "",
        identifyNo: "",
        customerAddress: "",
        deliverDate: "",
        isReport: true,
        remark: "",
        isOtherDealer: false,
        customerProvince: "",
        customerCity: "",
        customerCounty: "",
        extOrderId: "",
        orderReason: [],
        competeSeriesId: "",
        carInternalColor: '',
        carModelOptionals: {
          optional1: "",
          optional2: "",
          optional3: "",
          optional4: "",
          optional5: "",
          optional6: "",
          optional7: "",
          optional8: "",
          optional9: "",
        }, // 车型选装
        businessType: '', // 购车类型
      },
      formRules: {
        contractNo: [
          {
            required: true,
            message: "请输入合同编号",
            trigger: "blur"
          }
        ],
        orderType: [
          {
            required: true,
            message: "请选择订单类型",
            trigger: "blur"
          }
        ],
        modelId: [
          {
            required: true,
            message: "请选择订购车型",
            trigger: "blur"
          }
        ],
        modelColor: [
          {
            required: true,
            message: "请选择外观颜色",
            trigger: "blur"
          }
        ],
        isSanbao: [
          {
            required: true,
            message: "请选择是否三包车",
            trigger: "blur"
          }
        ],
        paymentDown: [
          {
            required: true,
            message: "请输入订金",
            trigger: "blur"
          }
        ],
        payType: [
          {
            required: true,
            message: "请选择付款方式",
            trigger: "blur"
          }
        ],
        paymentDeal: [
          {
            required: true,
            message: "请输入成交金额",
            trigger: "blur"
          }
        ],
        vehiclePurpose: [
          {
            required: true,
            message: "请选择车辆用途",
            trigger: "blur"
          }
        ],
        isReplace: [
          {
            required: true,
            message: "请选择是否置换",
            trigger: "blur"
          }
        ],
        customerType: [
          {
            required: true,
            message: "请选择客户类型",
            trigger: "blur"
          }
        ],
        customerName: [
          {
            required: true,
            message: "请输入订车人姓名",
            trigger: "blur"
          }
        ],
        identifyType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "blur"
          }
        ],
        identifyNo: [
          {
            required: true,
            message: "请输入证件号码",
            trigger: "blur"
          }
        ],
        customerPhone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur"
          }
        ],
        deliverDate: [
          {
            required: true,
            message: "请选择预计交车时间",
            trigger: "blur"
          }
        ],
        businessType: [
          {
            required: true,
            message: "请选择购车类型",
            trigger: "blur"
          }
        ]
      },
      orderTypeDics: [], // 订单类型
      orderLoadDurationDics: [], // 按揭期数
      orderVehiclePurposeDics: [], // 车辆用途
      orderIdentifyTypeDics: [], // 证件类型
      businessTypeOptions: [], // 购车类型
      orderStatusDics,
      carOptions: [], // 订购车型
      colors: [], //车辆颜色
      vins: [], // 车架号
      timelines: [],
      orderStatusList: [],
      secondDealers: [],
      show: false,
      adressProps: {
        // 省市区信息
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            order_vm.$httpAuth
              .post("/v2/appCustomerService/orderRegion", {
                dealerId: order_vm.dealer.dealerId,
                province: "",
                city: ""
              })
              .then(function (res) {
                const provinces = res.data.data.map((value) => ({
                  value: value,
                  label: value,
                  leaf: node.level >= 2
                }));
                resolve(provinces);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (node.level === 1) {
            order_vm.$httpAuth
              .post("/v2/appCustomerService/orderRegion", {
                dealerId: order_vm.dealer.dealerId,
                province: node.value,
                city: ""
              })
              .then(function (res) {
                const cities = res.data.data.map((value) => ({
                  value: value,
                  label: value,
                  leaf: node.level >= 2
                }));
                resolve(cities);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (node.level === 2) {
            order_vm.$httpAuth
              .post("/v2/appCustomerService/orderRegion", {
                dealerId: order_vm.dealer.dealerId,
                province: node.parent.value,
                city: node.value
              })
              .then(function (res) {
                const countys = res.data.data.map((value) => ({
                  value: value,
                  label: value,
                  leaf: node.level >= 2
                }));
                resolve(countys);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      },
      provinces: [],
      citys: [],
      countys: [],
      showViewer: false,
      failProductReasonDics: [],
      competitionSeries: [],
      carInternalColor: [],
      carModelOptionalsMaps: {}
    };
  },
  computed: { 
    carModelOptionalsComputed() {
      let value = {}
      for (const key in this.carModelOptionalsMaps) {
        if(Object.prototype.hasOwnProperty.call(this.carModelOptionalsMaps, key) && this.carModelOptionalsMaps[key] && this.carModelOptionalsMaps[key].some(Boolean)) {
          value[key] = this.carModelOptionalsMaps[key]
        }
      }
      return value
    }
  },
  created() {
    var baseInfo = this.$common.getBaseInfo();
    this.orderTypeDics = baseInfo.orderTypeDics;
    this.orderLoadDurationDics = baseInfo.orderLoadDurationDics;
    this.orderVehiclePurposeDics = baseInfo.orderVehiclePurposeDics;
    this.orderIdentifyTypeDics = baseInfo.orderIdentifyTypeDics;
    this.failProductReasonDics = baseInfo.failProductReasonDics;
    this.businessTypeOptions = baseInfo.businessTypes;
    this.retrieveCarOptions();
    this.getOrder();
    this.getProvinces();
    this.getCompetitionSeriesesOptions();
  },
  mounted() {},
  methods: {
    // 返回
    back() {
      if (sessionStorage.getItem("form") === "customerDetail") {
        this.$router.push({
          path: "/customer/detail/" + this.form.customerId
        });
      } else if (sessionStorage.getItem("form") === "order") {
        this.$router.push({
          path: "/order/zzOrder"
        });
      } else if (this.type) {
        this.$router.push({
          path: "/activity/order-verify"
        });
      } else {
        this.$router.go(-1);
      }
    },
    getCompetitionSeriesesOptions() {
      this.$httpAuth
        .post("/v1/dealerRpc/getCompetitionSeriesList", {
          dealerId: this.dealer.dealerId,
          key: ""
        })
        .then((res) => {
          this.competitionSeries = res.data.data;
        });
    },
    closeViewer() {
      this.showViewer = false;
    },
    // 省改变
    provinceChange(val, isClear = true) {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: val,
          city: ""
        })
        .then((res) => {
          this.citys = res.data.data;
          if(isClear) {
            this.form.customerCity = "";
            this.form.customerCounty = "";
          }
        });
    },
    // 市改变
    cityChange(val, isClear = true) {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: this.form.customerProvince,
          city: val
        })
        .then((res) => {
          this.countys = res.data.data;
          if(isClear) {
            this.form.customerCounty = "";
          }
        });
    },
    // 获取省
    getProvinces() {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: "",
          city: ""
        })
        .then((res) => {
          this.provinces = res.data.data;
        });
    },
    //点击预览
    handlePictureCardPreview1(file) {
      this.fileList = this.fileList1.map((item) => item.url);
      const reg = /^https:\/\/.*$/;
      this.initialIndex = this.fileList1.findIndex((item) => {
        if (reg.test(file.url)) {
          return item.url == file.url;
        } else {
          return item.url == file.response;
        }
      });
      this.showViewer = true;
    },
    //点击预览
    handlePictureCardPreview2(file) {
      this.fileList = this.fileList2.map((item) => item.url);
      const reg = /^https:\/\/.*$/;
      this.initialIndex = this.fileList2.findIndex((item) => {
        if (reg.test(file.url)) {
          return item.url == file.url;
        } else {
          return item.url == file.response;
        }
      });
      this.showViewer = true;
    },
    // 去客户详情
    toCustomer() {
      this.$router.push({
        path: "/customer/detail/" + this.form.customerId
      });
    },
    parseTime(time, cFormat) {
      if (arguments.length === 0) {
        return null;
      }
      const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
      let date;
      if (typeof time === "object") {
        date = time;
      } else {
        if (("" + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      };
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === "a")
          return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
        if (result.length > 0 && value < 10) {
          value = "0" + value;
        }
        return value || 0;
      });
      return time_str;
    },
    retrieveCarOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/vehicleJsonTree", {
          dealerId: this.dealer.dealerId
        })
        .then(function (response) {
          parent.carOptions = response.data.data;
        });
    },
    changeSpecColor(val) {
      var modelId = val[1];
      this.form.modelColor = "";
      this.form.carInternalColor = ''
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      this.colors = [];
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/vehicleColor", {
          modelId: parseInt(modelId),
          dealerId: this.dealer.dealerId
        })
        .then(function (response) {
          that.colors = response.data.data;
        })
        .catch(() => {});
    },
    getVins() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/vehiclesByColor", {
          modelId: parseInt(this.form.modelId[0]),
          dealerId: this.dealer.dealerId,
          color: this.form.modelColor
        })
        .then(function (response) {
          that.vins = response.data.data;
        })
        .catch(() => {});
    },
    // 获取订单详情
    getOrder() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/orderDetail", {
          orderId: this.orderId,
          dealerId: this.dealer.dealerId
        })
        .then(function (res) {
          let data = res.data;
          that.timelines = data.timelines;
          let orderReason =  []
          if (data.purchaseInfo && data.purchaseInfo.orderReason != '') {
            orderReason = data.purchaseInfo.orderReason.split(',')
          }
          const competeSeriesId = data.purchaseInfo && data.purchaseInfo.competeSeriesId ? data.purchaseInfo.competeSeriesId : ''
          const { carInternalColor = '', carColor, choicePackage1Name, choicePackage2Name,
            choicePackage3Name, choicePackage4Name, choicePackage5Name, choicePackage6Name, choicePackage7Name, 
            choicePackage8Name, choicePackage9Name
           } = data.carInfo || {}
          that.form = {
            referrerName: data.order.referrerName || "无",
            referrerPhone: data.order.referrerPhone || "无",
            otdStatus: data.order.otdStatus,
            customerId: data.order.customerId,
            extOrderId: data.order.extOrderId,
            contractNo: data.order.contractNo,
            orderType: data.order.orderType || "",
            modelId: [],
            modelColor: carColor || that.data.order.modelColor,
            carInternalColor,
            carModelOptionals: {
              optional1: choicePackage1Name,
              optional2: choicePackage2Name,
              optional3: choicePackage3Name,
              optional4: choicePackage4Name,
              optional5: choicePackage5Name,
              optional6: choicePackage6Name,
              optional7: choicePackage7Name,
              optional8: choicePackage8Name,
              optional9: choicePackage9Name,
            }, // 车型选装
            modelVin: data.order.modelVin,
            isSanbao: data.order.isSanbao,
            paymentDown: data.order.paymentDown,
            payType: data.order.payType,
            paymentFirst: data.order.paymentFirst,
            paymentYears: data.order.paymentYears,
            paymentDeal: data.order.paymentDeal,
            paymentOther: data.order.paymentOther,
            vehiclePurpose: data.order.vehiclePurpose,
            isReplace: data.order.isReplace,
            customerType: data.order.customerType,
            customerName:
              data.order.customerType === 1
                ? data.order.customerName
                : data.order.companyName,
            customerPhone: data.order.customerPhone,
            identifyType: data.order.identifyType,
            identifyNo: data.order.identifyNo,
            customerAddress: data.order.customerAddress,
            deliverDate: data.order.deliverDate ? data.order.deliverDate * 1000 : '',
            isReport: data.order.isReport,
            remark: data.order.remark,
            isOtherDealer: data.order.isOtherDealer,
            customerProvince: data.order.customerProvince,
            customerCity: data.order.customerCity,
            customerCounty: data.order.customerCounty,
            images1: [],
            images2: [],
            orderReason,
            competeSeriesId,
            reactivateSource: data.reactivateSource || '',
            sourceName: data.sourceName || '',
            businessType: data.order.businessType || '',
          };
          // that.fileList1 = [];
          // that.fileList2 = [];
          if (data.order.images1 != "") {
            that.form.images1 = data.order.images1.split(",")
          }
          if (data.order.images2 != "") {
            that.form.images2 = data.order.images2.split(",")
          }
          that.provinceChange(data.order.customerProvince, false);
          that.cityChange(data.order.customerCity, false);
          setTimeout(() => {
            that.form.customerCity = data.order.customerCity;
            that.form.customerCounty = data.order.customerCounty;
          }, 300);
          that.getmodelId(data.order.modelId);
        })
        .catch(() => {});
    },
    getmodelId(id) {
      var that = this;
      this.$httpAuth
        .post("/v1/baseRpc/getSpec", {
          id: id
        })
        .then(function (res) {
          that.form.modelId = [
            res.data.spec.seriesId + "",
            res.data.spec.id + ""
          ];
          that.getCarModelDetail();
          that.getCarModelOptionals()
          that.form.colors = res.data.spec.colors.split(",");
        })
        .catch(() => {});
    },
    getCarModelDetail() {
      this.$httpAuth
        .post("/v2/appVerifyService/getCarModelDetail", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carWheelBoss: "",
          carWheel: "",
          carInternalColor: this.form.carInternalColor
        })
        .then((res) => {
          this.carInternalColor = res.data.carInternalColor;
        });
    },
    getCarModelOptionals() {
      this.$httpAuth
        .post("/v2/appVerifyService/getCarModelOptionals", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carInternalColor: this.form.carInternalColor
        })
        .then((res) => {
          this.carModelOptionalsMaps = res.data;
        });
    },
    formatReferrerName(str = "") {
      return (
        str.replace(
          /^(.{1})(.*)$/,
          (match, p1, p2) => p1 + p2.replace(/./g, "*")
        ) || "--"
      );
    },
    formatReferrerPhone(str = "") {
      return (
        str.replace(
          /^(.{3})(.*)(.{4})$/,
          (match, p1, p2, p3) => p1 + p2.replace(/./g, "*") + p3
        ) || "--"
      );
    },
    // 获取二级店
    getSecondDealers() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/orderSecondDealers", {
          dealerId: this.dealer.dealerId
        })
        .then(function (res) {
          that.secondDealers = res.data.data;
        })
        .catch(() => {});
    }
  },
  watch: {},
  filters: {
    orderStatus(val) {
      for (var i = 0; i < order_vm.orderStatusDics.length; i++) {
        var o = order_vm.orderStatusDics[i];
        if (o.orderStatus == val) {
          return o.name;
        }
      }
      return "";
    }
  }
};
</script>
<style scoped>
.back {
  font-size: 14px;
}

.el-step__title {
  font-size: 14px;
}

.mt2 {
  margin-top: 20px;
}

.mt1 {
  margin-top: 10px;
}

.title {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(10, 18, 32, 0.64);
  letter-spacing: normal;
  margin-bottom: 15px;
  margin-top: 10px;
}

.form_item {
  margin-bottom: 15px !important;
}

.tips {
  width: 100%;
  text-align: center;
  font-weight: 600;
  margin-bottom: 20px;
}

.submit-fo {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.ps {
  width: 100%;
  text-align: center;
  height: 70px;
  font-size: 12px;
  line-height: 40px;
}

.boxLine {
  width: 250px;
  padding: 5px 0 5px 10px;
  border: 1px solid #e8ebed;
  font-size: 12px;
}

.boxLine .title {
  font-weight: 600;
  color: #000;
}

.el-timeline-item__wrapper {
  position: relative;
}

.el-timeline-item__timestamp {
  position: absolute;
  left: -110px;
  top: 0;
}

.toCustomer {
  color: rgb(64, 158, 255);
  cursor: pointer;
  margin-left: 10px;
  font-weight: 400;
}

.hide .el-upload--picture-card {
  display: none;
}

.el-upload-list__item {
  width: 90px !important;
  height: 90px !important;
}

.el-upload {
  width: 90px !important;
  height: 90px !important;
  line-height: 90px !important;
}

.el-image-viewer__btn .el-icon-circle-close {
  color: #fff;
}
</style>
